import React, { Fragment } from 'react';
import styled from 'styled-components';
import _ from 'lodash';

import { HorizontalDivider } from 'components/core/divider';
import { ListContainer } from '../../components';
import SubscriptionListItem from './subscription-list-item';

// TODO: Confirm if there's a loading state
const SubscriptionList = ({ subscriptions, onToggleSubscribe, subscriptionsToCancel }) => {
  const subscriptionsToDisplay = _.filter(subscriptions, `emailSubscription`);

  return (
    <ListContainer>
      {_.map(subscriptionsToDisplay, ({ _id: id, dispensary }, i) => {
        const { logoImage, location, name: dispensaryName } = dispensary;
        const displayDivider = i !== subscriptions.length - 1;
        const unSubscribed = _.includes(subscriptionsToCancel, id);
        const dispensaryLocation = `${location.city}, ${location.state}`;

        const toggleSubscribe = () => onToggleSubscribe(id);

        return (
          <Fragment key={id}>
            <SubscriptionListItem
              dispensaryName={dispensaryName}
              location={dispensaryLocation}
              unSubscribed={unSubscribed}
              onToggleSubscribe={toggleSubscribe}
              dispensaryLogo={logoImage}
            />

            {displayDivider && <StyledHorizontalDivider />}
          </Fragment>
        );
      })}
    </ListContainer>
  );
};

export default SubscriptionList;

const StyledHorizontalDivider = styled(HorizontalDivider)`
    margin-top: 22px;
    margin-bottom: 20px;

  ${({ theme }) => theme.breakpoints.up('md')} {
    margin-top: 26px;
    margin-bottom: 21px;
  }}
`;
